import { cn } from "@app/lib/utils";
import type { ComponentProps } from "react";

type ErrorInputProps = ComponentProps<"div">;

export function ErrorInput({ children, className, ...props }: ErrorInputProps) {
  if (!children) {
    return null;
  }

  return (
    <div {...props} className={cn("text-sm text-red-500", className)}>
      {children}
    </div>
  );
}
